// extracted by mini-css-extract-plugin
export default {"newsBanner":"newsBanner_newsBanner__xWYII"};